import React, { Component, Fragment } from "react";
import CheckAuth from "../../../utils/hoc/CheckAuth";
// import { Button } from 'react-bootstrap';
import DataTable from "../../organism/DataTable";
import ReactDOM from "react-dom";
import Button from "../../../components/atoms/Button";
import { connect } from "react-redux";
import Loan from "../../../redux/actions/Loan";
import Loading from "../../../components/molecules/Loading";
import InformationText from "../../../components/molecules/InformationText";
import curencyFormat from "../../../utils/helpers/curencyFormat";

class PengajuanPinjaman extends Component {
	constructor(props) {
		super(props);
		this.state = {
			coloumnDataTable: [
				{ data: "loanCode", width: "140", title: "Kode Pinjaman" },
				{ data: "nameProductMapping", width: "150", title: "Tipe Pinjaman" },
				{ data: "loanProgress", width: "150", title: "Status" },
				{ data: "loanAmount", width: "100", title: "Nilai Pinjaman" },
				/*{ data: "collateralType", width: "100", title: "Tipe Jaminan" },
				{ data: "collateralDetail", width: "100", title: "Nilai Jaminan" },*/
				{ data: "loanPurpose", width: "150", title: "Tujuan Pinjaman" },
				{ data: "loanCode", width: "100", title: "" },
			],
			coloumnDefs: [
				{
					targets: [0, 1, 2, 4],
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span>{cellData || "-"}</span>, td);
					},
				},
				{
					targets: 3,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span> Rp {cellData ? curencyFormat(cellData) : "-"} </span>, td);
					},
				},
				/*{
					targets: 3,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span> Rp {cellData.invoiceAmount ? curencyFormat(cellData.invoiceAmount) : "-"} </span>, td);
					},
				},*/
				{
					targets: 5,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<Button title={"Lihat"} onClick={() => this.gotoDetail(cellData)} type={"button"} color="blue" width="small" />, td);
					},
				},
			],
			statusLoan: ["SB1", "RV1", "AP0", "AC0"],
		};
	}
	componentDidMount = () => {
		console.log("====================================");
		console.log("disini === ", this.props.ClientID);
		console.log("====================================");
		this.props.setTitlePage({
			title: "Pengajuan Pinjaman",
			breadcrumb: [
				{ name: "Beranda", url: "/dashboard", status: false },
				{ name: "Pengajuan Pinjaman", url: "/#", status: true },
			],
		});
		if (this.props.ClientID !== null) {
			this.props.getListLoan(this.props.ClientID, this.state.statusLoan);
		}
	};
	gotoDetail = (loancode) => {
		this.props.history.push(`pengajuan-pinjaman/detil/${loancode}`);
	};
	render() {
		let { data, coloumnDataTable, coloumnDefs } = this.state;
		// let { loan } = this.props
		const { list, loading } = this.props.loan;

		return <Fragment>{!loading ? <DataTable data={list} coloumn={this.state.coloumnDataTable} fixedWidthColoumn={true} coloumnDefs={this.state.coloumnDefs} /> : <Loading />}</Fragment>;
	}
}
const mapStateToProps = (state) => {
	return {
		loan: state.loanState,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getListLoan: (ClientID, status) => {
			dispatch(Loan(ClientID, status));
		},
	};
};
export default CheckAuth(connect(mapStateToProps, mapDispatchToProps)(PengajuanPinjaman));
